// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"ea47848c","390":"93eea154","398":"8b739baf","444":"81efc9d1"}[chunkId] + ".chunk.js";
};